import {
  Star,
  Gift,
  // Coffee
} from 'lucide-preact';

import { useWidgetConfig } from '@/context/WidgetConfigContext';
import {
  getProgramDescription,
  hasCouponsProgram,
  hasPointsProgram,
  hasTiersProgram,
} from '@/helpers/functions/loyalty';
import { E_EnableLoyaltyProgramName } from '@/types/Shopify';
import type { I_ConfiguredProgramsProps } from '@/types/UnregisteredCustomer';

import { ProgramPreviewCards } from './ProgramPreviewCards';

export const ConfiguredPrograms = ({ loyaltyPrograms }: I_ConfiguredProgramsProps) => {
  const { theme } = useWidgetConfig();
  const iconColor = theme?.headingColor;

  const PROGRAMS = loyaltyPrograms
    ? [
        {
          icon: <Star className='h-6 w-6' style={{ color: iconColor }} />,
          title: 'Tier Program',
          description: getProgramDescription(
            loyaltyPrograms,
            E_EnableLoyaltyProgramName.TIERS_PROGRAM,
          )!,
          // color: 'bg-yellow-50 text-yellow-700',
          isShown: hasTiersProgram(loyaltyPrograms),
        },
        {
          icon: <Gift className='h-6 w-6' style={{ color: iconColor }} />,
          title: 'Points Program',
          description: getProgramDescription(
            loyaltyPrograms,
            hasPointsProgram(loyaltyPrograms)
              ? E_EnableLoyaltyProgramName.POINTS_PROGRAM
              : E_EnableLoyaltyProgramName?.COUPONS_PROGRAM,
          )!,
          // color: 'bg-blue-50 text-blue-700',
          isShown: hasPointsProgram(loyaltyPrograms) || hasCouponsProgram(loyaltyPrograms),
        },
        // {
        //   icon: <Coffee className="h-6 w-6" />,
        //   title: 'Punch Card',
        //   description: getProgramDescription(
        //     loyaltyPrograms,
        //     E_EnableLoyaltyProgramName.PUNCH_CARDS_PROGRAM,
        //   )!,
        //   color: 'bg-green-50 text-green-700',
        //   isShown: hasPunchCardsProgram(loyaltyPrograms),
        // }, // TODO: GET THIS BACK WHEN WE HAVE PUNCH CARD
      ]
    : [];
  return <ProgramPreviewCards programs={PROGRAMS} />;
};
